const COOKIE_NAME = 'tx_site_lang';
const COOKIE_DAYS = 365;

// Mapping ISO-Code → URL-Basis (muss zur site config.yaml passen)
const LANG_BASES: Record<string, string> = {
    de: '/',
    en: '/en/',
};

function getCookie(name: string): string | null {
    const match = document.cookie.match(
        new RegExp('(^|;\\s*)' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie =
        `${name}=${encodeURIComponent(value)}` +
        `; expires=${expires.toUTCString()}` +
        `; path=/; SameSite=Lax`;
}

function getCurrentLang(): string {
    return (document.documentElement.lang || 'de').substring(0, 2).toLowerCase();
}

function buildTargetUrl(targetLang: string): string {
    let path = window.location.pathname;

    for (const [lang, base] of Object.entries(LANG_BASES)) {
        if (lang === 'de') continue;
        if (path.startsWith(base)) {
            path = '/' + path.slice(base.length);
            break;
        }
    }

    const newBase = LANG_BASES[targetLang] ?? '/';
    const newPath = newBase === '/'
        ? path
        : newBase + path.replace(/^\//, '');

    return newPath + window.location.search + window.location.hash;
}

function initLangDetect(): void {
    // Cookie gesetzt → Nutzer hat bereits eine Sprachpräferenz → kein Redirect
    if (getCookie(COOKIE_NAME)) return;

    const browserLang = (navigator.language ?? 'de').substring(0, 2).toLowerCase();
    const currentLang = getCurrentLang();

    // Cookie direkt beim ersten Besuch setzen
    setCookie(COOKIE_NAME, currentLang, COOKIE_DAYS);

    // Nur weiterleiten wenn Browsersprache bekannt und abweichend
    if (browserLang in LANG_BASES && browserLang !== currentLang) {
        window.location.replace(buildTargetUrl(browserLang));
    }
}

function initLangSwitchListener(): void {
    document.addEventListener('click', (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        const link = target.closest<HTMLAnchorElement>('[data-lang]');
        if (!link) return;

        const lang = link.getAttribute('data-lang');
        if (lang) setCookie(COOKIE_NAME, lang, COOKIE_DAYS);
    });
}

// Einstiegspunkt
initLangDetect();
initLangSwitchListener();
